<div class="mb-2">
  <!-- Label -->
  <label class="text-medium block mb-6">
    {{ label | translate }}
  </label>

  <!-- Checkbox grid -->
  <div class="flex gap-x-10 gap-y-6 flex-wrap">
    <div
      *ngFor="let option of options"
      class="flex items-center gap-4 cursor-pointer select-none"
      (click)="toggleSelection(option.value)"
    >
      <!-- Circle check -->
      <div
        class="w-6 h-6 flex items-center justify-center rounded-full border-2 transition-all"
        [ngClass]="{
          'bg-(--brand-primary) border-(--brand-primary)': isSelected(option.value),
          'border-(--text-placeholder)': !isSelected(option.value)
        }"
      >
        <img
          *ngIf="isSelected(option.value)"
          src="assets/icons/check-white.svg"
          alt="checked"
          class="w-3.5 h-3.5"
        />
      </div>

      <!-- Label text -->
      <span
        class="text-medium"
        [ngClass]="{
          'text-(--text-primary)': isSelected(option.value),
          'text-(--text-secondary)': !isSelected(option.value)
        }"
      >
        {{ option.label | translate }}
      </span>
    </div>
  </div>
</div>
